import { ref } from 'vue';
import { type RouteRecordRaw } from 'vue-router';

import { type SharedPluginOptions } from '@deepidoo/deesplay/plugins';

import { routes } from '../features/main.router';
import coreDeDE from '../translations/de-DE.json';
import coreEnUS from '../translations/en-US.json';
import coreEsES from '../translations/es-ES.json';
import coreFrFR from '../translations/fr-FR.json';
import coreItIT from '../translations/it-IT.json';
import corePtPT from '../translations/pt-PT.json';
import coreZhCN from '../translations/zh-CN.json';

export interface CorePluginOptions extends SharedPluginOptions {
	routes: RouteRecordRaw[];
};

export const defaultOptions = ref<CorePluginOptions>({
	locale: 'fr-FR',
	fallbackLocale: 'fr-FR',
	message: {
		'de-DE': coreDeDE,
		'en-US': coreEnUS,
		'es-ES': coreEsES,
		'fr-FR': coreFrFR,
		'it-IT': coreItIT,
		'pt-PT': corePtPT,
		'zh-CN': coreZhCN
	},
	routes: routes,
	theme: 'LIGHT',
	themes: {
		LIGHT: {},
		DARK: {}
	}
});
